'use client';

import React from 'react';
import Image from 'next/image';
import {useSkillzStyle} from '@/app/games/[gid]/_src/SkillzStyleProvider';
import skillzLogo from 'public/skillzLogo.svg';

function ProgressBar({progress}: {progress: number}) {
  const {themeJSON: theme} = useSkillzStyle();
  const {viewPrimaryColor, progressBarColor} = theme.sheetStyles;
  const loadingBarBackground = viewPrimaryColor.backgroundColor;
  const loadingBarColor = progressBarColor.backgroundColor;

  return (
    <div className='w-full flex justify-center items-center flex-col'>
      <div
        className='w-1/2 h-5 bg-black dark:bg-white rounded-md flex justify-start pl-1 items-center'
        style={{
          backgroundColor: loadingBarBackground,
        }}
      >
        <div
          className='h-3 bg-white dark:bg-black rounded-sm transition-all duration-200 mr-1'
          style={{
            backgroundColor: loadingBarColor,
            width: `${Math.min(progress * 100, 100)}%`,
          }}
        ></div>
      </div>
    </div>
  );
}

function StaticLoader() {
  return (
    <div className='w-full flex justify-center items-center'>
      <span className='w-8 inline-flex justify-between items-center mx-6'>
        <div className='h-2 w-2 dark:bg-white bg-black rounded-full animate-[opacity_3s_ease-in-out_infinite] animation-delay-[1000ms]'></div>
        <div className='h-2 w-2 dark:bg-white bg-black rounded-full animate-[opacity_3s_ease-in-out_infinite] animation-delay-[1150ms]'></div>
        <div className='h-2 w-2 dark:bg-white bg-black rounded-full animate-[opacity_3s_ease-in-out_infinite] animation-delay-[1300ms]'></div>
      </span>
    </div>
  );
}

type Props = {
  progress?: number;
  withUI?: boolean;
};

export default function LoadingScreen({progress, withUI}: Props) {
  const {gameTitle, gameIcon} = useSkillzStyle();

  const showProgressBar = typeof progress !== 'undefined';
  const height = withUI ? 'h-[calc(100dvh_-_80px)]' : 'h-screen';

  return (
    <div
      className={`w-screen ${height} flex flex-col gap-y-4 justify-center items-center flex-wrap`}
    >
      <div className='w-full flex justify-center items-center rounder-xl'>
        <Image
          src={gameIcon ?? skillzLogo}
          className='animate-[scale_3s_linear_infinite] rounded-md'
          alt={gameIcon ? gameTitle : 'Skillz'}
          width={50}
          height={50}
          priority={true}
        />
      </div>
      {showProgressBar ? <ProgressBar progress={progress} /> : <StaticLoader />}
    </div>
  );
}
